module.exports = __webpack_public_path__ + "img/ticket_btn.28fd5182.png";